// extracted by mini-css-extract-plugin
module.exports = {"container":"infoCards_container__2fQM4","cardTitle":"infoCards_cardTitle__2hCTw","copy":"infoCards_copy__3h_8H","div":"infoCards_div__2Iy_q","readmore":"infoCards_readmore__qppEK"};